import TrackedBill from './TrackedBill'
import User from './User'
export default class TrackedBillAssignment {
  constructor(objIn = {}) {
    const defaults = {
      //TrackedBillID is required
      TrackedBillID: 0,
      //UserID is required
      UserID: 0,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.TrackedBillID = obj.TrackedBillID
    this.UserID = obj.UserID
    this.TrackedBill = new TrackedBill(obj.TrackedBill || {})
    this.User = new User(obj.User || {})
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.TrackedBill = null
    obj.User = null
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.TrackedBill = null
    obj.User = null
    return obj
  }
}
